<template>
  <div class="edit-rental-min-stay" v-show="editRentalMinStay">
    <div class="panel panel-white panel-min-stay left">
      <div class="pannel_sec">
        <div class="cross_icon" @click.prevent="closeEditRentalMinStayModal()">
          x
        </div>
        <div class="pannel_details">
          <div class="rental-name-section">
            <h2 class="tle_p">
              <div class="rental-name">
                {{ rentalMinStayData.rentalName }}
              </div>
            </h2>
          </div>
          <div class="edit-min-stay-section">
            <div class="form-group form-material">
              <label class="control-label">
                {{ $t("calendar.index.min_stay.title") }}
              </label>
              <span class="required">*</span>
              <input
                type="text"
                class="form-control"
                v-model="rentalMinStayData.minStayNumber"
              />
            </div>
            <div class="form-group form-material">
              <label class="control-label">
                {{ $t("input.start_date") }}
              </label>
              <span class="required">*</span>
              <datepicker
                class="form-control"
                id="edit-min-stay-start-date"
                v-model="rentalMinStayData.startDate"
                :disabled-dates="startDate.disabled"
                :language="language === 'fr' ? fr : en"
                format="D dd MMMM yyyy"
              ></datepicker>
            </div>
            <div class="form-group form-material">
              <label class="control-label">
                {{ $t("input.end_date") }}
              </label>
              <span class="required">*</span>
              <datepicker
                class="form-control"
                id="edit-min-stay-end-date"
                :disabled-dates="endDate.disabled"
                v-model="rentalMinStayData.endDate"
                :language="language === 'fr' ? fr : en"
                format="D dd MMMM yyyy"
              ></datepicker>
            </div>
            <div class="row week-days">
              <ul class="week-day-name d-flex align-items-center">
                <li
                  class="checkbox-custom checkbox-inline checkbox-primary dropdown-item d-flex align-items-center"
                  v-for="(day, index) in rentalMinStayData.weekDays"
                  @click="selectWeekDays(index)"
                >
                  <input
                    type="checkbox"
                    v-model="rentalMinStayData.weekDays[index].selected"
                  />
                  <label class="d-flex align-items-center">
                    <span>{{
                      $t(`calendar.index.week_days.${day.name}`)
                    }}</span>
                  </label>
                </li>
              </ul>
            </div>
            <div class="form-group form-material">
              <v-loading
                :isLoading="smallLoading"
                :height="50"
                :width="50"
                :viewbox="'0 0 50 50'"
                :cx="25"
                :cy="25"
                :r="22"
                :isHeightAuto="true"
              ></v-loading>
              <button
                type="button"
                class="btn btn-red btn-bold waves-effect waves-classic btn-with-caret"
                @click.prevent="modifyMinStay(rentalMinStayData)"
                :disabled="smallLoading"
              >
                {{ $t("button.save") }}
              </button>
            </div>
            <div
              v-if="hasPermissionForMultiSelect"
              class="checkbox-custom checkbox-primary"
            >
              <input
                type="checkbox"
                id="min-stay-multiple-modification"
                v-model="enableMultipleModification"
                :disabled="disabledCheckbox"
              />
              <label for="min-stay-multiple-modification">{{
                $t("multiple_modifications")
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import rentalService from "../../../services/rental";
import mixin from "../../../mixins/mixin";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import bookingComService from "../../../services/booking-com";

export default {
  name: "EditMinStay",
  data() {
    return {
      en: en,
      fr: fr,
      smallLoading: false,
      language: localStorage.getItem("lang") || "fr",
      onceOpened: 1,
      startDate: {
        disabled: {
          to: null,
          from: moment().add(2, "years").toDate(),
        },
      },
      endDate: {
        disabled: {
          to: null,
          from: moment().add(2, "years").toDate(),
        },
      },
      weekDaysInfo: {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
      },
      minStayToEdit: {},
      enableMultipleModification: false,
      disabledCheckbox: false,
      isUpdatedMinStay: false,
    };
  },

  props: [
    "editRentalMinStay",
    "rentalMinStayData",
    "from",
    "to",
    "minStayRentalsIds",
    "enableOpenModal",
    "hasPermissionForMultiSelect",
  ],

  mixins: [mixin],

  components: {
    VLoading: require("components/loading/loading.vue"),
    Datepicker,
  },

  watch: {
    "rentalMinStayData.startDate"(newValue, oldValue) {
      if (typeof newValue === "string") {
        newValue = new Date(
          newValue
        );
      }
      this.onceOpened = oldValue ? 0 : 1;
      let startDate = this.rentalMinStayData.startDate;
      
      if (typeof startDate === "string") {
        startDate = new Date(
          startDate
        );
        this.rentalMinStayData.startDate = startDate;
      }
      if (moment(this.rentalMinStayData.endDate).diff(startDate, "days") <= 0) {
        this.rentalMinStayData.endDate = moment(startDate)
          .add(1, "day")
          .toDate();
      }
      const newDate = new Date(startDate);
      this.endDate.disabled.to = new Date(
        newDate.setDate(newDate.getDate() - this.onceOpened)
      );
    },

    "rentalMinStayData.endDate"() {
      // let endDate = this.rentalMinStayData.endDate;
      // let newDate = new Date(endDate);
      // this.startDate = {
      //   disabled: {
      //     to: null,
      //     from: new Date(newDate.setDate(newDate.getDate())),
      //   },
      // };
    },

    "account.lang": function (newVal) {
      this.language = newVal;
    },

    enableOpenModal(val) {
      if (!val) {
        this.enableMultipleModification = false;
      }
    },

    minStayRentalsIds(val) {
      if (val.length > 0) {
        this.updateRentalMinStay(this.minStayToEdit, val);
      }
    },

    isUpdatedMinStay(val) {
      if (val) {
        this.$emit("updateMultiSelectModal");
        this.isUpdatedMinStay = false;
      }
    },
  },

  methods: {
    modifyMinStay(data) {
      if (this.enableMultipleModification) {
        this.minStayToEdit = data;
        this.$emit(
          "openMultiSelectModal",
          null,
          true,
          "minStay",
          this.enableMultipleModification
        );
      } else {
        this.updateRentalMinStay(data);
      }
    },

    async updateRentalMinStay(data, rentalsIds = []) {
      this.disabledCheckbox = true;
      this.smallLoading = true;
      data.startDate = moment(data.startDate, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      );
      data.endDate = moment(data.endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
      let minStayData = null;

      minStayData = {
        startDate: data.startDate,
        endDate: data.endDate,
        rentalId: data.rentalId,
        type: "SetMinLOS",
        minStayNumber: data.minStayNumber,
        weekDays: [],
      };
      if (rentalsIds.length > 0) {
        minStayData.rentalsIds = rentalsIds;
      }

      this.rentalMinStayData.selectedWeekDays.map((weekDayName) => {
        minStayData.weekDays.push(this.weekDaysInfo[weekDayName]);
      });

      await bookingComService.updateMinMaxStay(this, minStayData);

      await this.$emit(
        "getRentals",
        this.from,
        this.to,
        minStayData && minStayData.rentalId ? minStayData.rentalId : null,
        minStayData && minStayData.rateId ? minStayData.rateId : null
      );
    },

    closeEditRentalMinStayModal() {
      this.$emit("closeEditRentalMinStayModal");
    },

    selectWeekDays(index) {
      this.rentalMinStayData.weekDays[index].selected =
        !this.rentalMinStayData.weekDays[index].selected;
      this.rentalMinStayData.selectedWeekDays = [];
      for (let i = 0; i < this.rentalMinStayData.weekDays.length; i++) {
        this.rentalMinStayData.weekDays[i].selected &&
          this.rentalMinStayData.selectedWeekDays.push(
            this.rentalMinStayData.weekDays[i].full_name
          );
      }
    },
  },

  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};
</script>



// WEBPACK FOOTER //
// EditMinStay.vue?9e27685a